import AppRoute from './AppRoute';

const AppConstants = {
  // ---- tram sac ----
  // trang thai tram sac
  chargeStationStatus: {
    normal: 'NORMAL',
    maintaining: 'MAINTAINING',
    pending: 'PENDING',
    stopped: 'STOPPED',
    hidden: 'HIDDEN',
  },

  // ---- tru sac ----
  // trang thai tru sac
  chargePointStatus: {
    maintaining: 'MAINTAINING',
    available: 'AVAILABLE',
    busy: 'BUSY',
    fault: 'FAULT',
    notConnected: 'NOT_CONNECTED',
  },
  // trang thai voi sac
  chargeConnectorStatus: {
    available: 'AVAILABLE',
    preparing: 'PREPARING',
    charging: 'CHARGING',
    suspended: 'SUSPENDED',
    finishing: 'FINISHING',
  },
  // ---- phien sac ----
  chargeTransactionStatus: {
    finished: 'FINISHED',
    battery_returned: 'BATTERY_RETURNED',
    battery_picked_up: 'BATTERY_PICKED_UP',
    initiating: 'INITIATING',
    waiting_pick_up: 'WAITING_PICK_UP',
    waiting_return: 'WAITING_RETURN',
    pick_up_expired: 'PICK_UP_EXPIRED',
    failed: 'FAILED',
    cancelled: 'CANCELLED',
  },

  // trang thai giao dich thanh toan
  paymentTransactionStatus: {
    completed: 'COMPLETED',
    pending: 'PENDING',
    failed: 'FAILED',
  },

  // trang thai giao dich nap tien
  topupTransactionStatus: {
    completed: 'COMPLETED',
  },
  // trang thai chu dat
  landownerStatus: {
    normal: 'NORMAL',
    maintaining: 'MAINTAINING',
    pending: 'PENDING',
    stopped: 'STOPPED',
  },

  // danh sach nhom quyen
  userRole: {
    admin: 'ADMIN',
    operator: 'OPERATOR',
    agency: 'AGENCY',
    maintainer: 'MAINTAINER',
  },

  userAgencyType: {
    sale: 'SALE',
    investor: 'INVESTOR',
    landlord: 'LANDLORD',
    group: 'GROUP',
    chargepoint: 'CHARGEPOINT',
  },

  // trang thai dai ly
  agencyStatus: {
    normal: 'NORMAL',
    signed: 'SIGNED',
    suspended: 'SUSPENDED',
    deleted: 'DELETED',
    registered: 'REGISTERED',
  },

  // cap dai ly
  agencyLevel: {
    level0: 'Tổng đại lý',
    level1: 'Miền',
    level2: 'Khu vực',
    level3: 'Văn phòng',
    level4: 'Trưởng nhóm',
    level5: 'Cộng tác viên',
  },

  agencyType: {
    sale: 'SALE',
    investor: 'INVESTOR',
  },

  investorType: {
    individual: 'INDIVIDUAL',
    organization: 'ORGANIZATION',
  },

  orderStatus: {
    ordered: 'ORDERED',
    shipping: 'SHIPPING',
    installing: 'INSTALLING',
    installed: 'INSTALLED',
    completed: 'COMPLETED',
  },

  // trang thai ban hang
  saleStatus: {
    ordered: 'ORDERED',
    shipping: 'SHIPPING',
    installing: 'INSTALLING',
    installed: 'INSTALLED',
    completed: 'COMPLETED',
  },

  salePaymentStatus: {
    unpaid: 'UNPAID',
    processing: 'PROCESSING',
    paid: 'PAID',
  },

  agencyTransactionStatus: {
    requested: 'REQUESTED',
    processing: 'PROCESSING',
    paid: 'PAID',
    rejected: 'REJECTED',
  },

  investorEnergyCommissionMode: [
    { value: 'FIXED_PER_KWH', name: 'Hoa hồng cố định theo số điện' },
    { value: 'PERCENT_INPUT', name: 'Hoa hồng tỉ lệ theo giá điện mua của nhà nước' },
    { value: 'PERCENT_OUTPUT', name: 'Hoa hồng tỉ lệ theo giá điện bán ra' },
    { value: 'PERCENT_PROFIT', name: 'Hoa hồng tỷ lệ theo lợi nhuận' },
  ],

  energyCommissionMode: {
    fixedPerKwh: 'FIXED_PER_KWH',
    percentInput: 'PERCENT_INPUT',
    percentOutput: 'PERCENT_OUTPUT',
    percentProfit: 'PERCENT_PROFIT',
    fixedPerMonth: 'FIXED_PER_MONTH',
  },

  accountType: {
    individual: 'INDIVIDUAL',
    organization: 'ORGANIZATION',
  },

  // trang thai hoa don tien dien
  energyBillStatus: {
    pending: 'PENDING',
    validated: 'VALIDATED',
  },

  idCardType: {
    cc: 'CC',
    hc: 'HC',
  },

  createdBy: {
    me: 'ME',
    others: 'OTHERS',
    self: 'SELF',
  },

  userRoleRouteWhiteList: {
    ADMIN: [
      AppRoute.listSessionPin,
      AppRoute.listRetrievalAReturnPin,
      AppRoute.listReturnCar,
      AppRoute.manageOrderService,
      AppRoute.oderRentPin,
      AppRoute.oderRentCar,
      AppRoute.oderBuyECar,
      AppRoute.manageDeposit,
      AppRoute.manageCustomer,
      AppRoute.listCustomer,
      AppRoute.transactionCustomerDeposit,
      AppRoute.manageAgency,
      AppRoute.listAgency,
      AppRoute.reportReconciliationAgency,
      AppRoute.groupPermissionAgency,
      AppRoute.managePartner,
      AppRoute.listInvestorHTKD,
      AppRoute.listPackageInvestorHTKD,
      AppRoute.reportReconciliationNDTHTKD,
      AppRoute.listNDTNQ,
      AppRoute.landlordList,
      AppRoute.partnerOperateCarFleet,
      AppRoute.listPartnerOperateCarFleet,
      AppRoute.reportPartnerOperateCarFleet,
      AppRoute.maintenanceRepair,
      AppRoute.listTechnician,
      AppRoute.listTask,
      AppRoute.reportReconciliationTechnician,
      AppRoute.manageGeneralInfo,
      AppRoute.dashboard,
      AppRoute.manageChargeStations,
      AppRoute.stationList,
      AppRoute.pointList,
      AppRoute.stationsMap,
      AppRoute.batteryList,
      AppRoute.manageVehicles,
      AppRoute.manageVehicleBrand,
      AppRoute.vehicleList,
      AppRoute.operatorVehicleList,
      AppRoute.rfidList,
      AppRoute.packageServiceCustomer,
      AppRoute.packageRentAChangeBattery,
      AppRoute.packageRentCar,
      AppRoute.monitoringCenter,
      AppRoute.mapStationPin,
      AppRoute.mapStatusPin,
      AppRoute.mapTram,
      AppRoute.mapUsageDensity,
      AppRoute.manageChargeBrand,
      AppRoute.inventoryList,
      AppRoute.valuationList,
      AppRoute.insurancePackList,
      AppRoute.voucherList,
      AppRoute.managePaymentTransactions,
      AppRoute.withdrawTransactionList,
      AppRoute.commissionTransactionList,
      AppRoute.managePayments,
      AppRoute.manageStaffs,
      AppRoute.staffList,
      AppRoute.staffPermissionList,
      AppRoute.manageGroupPermissionInvestor,
      AppRoute.manageGroupPermissionLandlord,
      AppRoute.partnerPermissionList,
      AppRoute.manageOperators,
      AppRoute.customerList,
      AppRoute.managePartners,
      AppRoute.manageDealership,
      AppRoute.saleList,
      AppRoute.saleReport,
      AppRoute.groupList,
      AppRoute.groupReport,
      AppRoute.investmentPackList,
      AppRoute.investorReport,
      AppRoute.landlordsList,
      AppRoute.landlordList,
      AppRoute.landlordReport,
      AppRoute.systemLogList,
      AppRoute.actionLogList,
      AppRoute.superDashboard,
      AppRoute.manageSystem,
      AppRoute.orderList,
      AppRoute.setting,
      AppRoute.pushNotificationList,
      AppRoute.agencyConfigCommission,
      AppRoute.poaContract,
      AppRoute.energyBillList,
      // AppRoute.chargeMaintain,
      // AppRoute.chargeInstallation,
      AppRoute.premisesList,
      AppRoute.tutorialList,
      AppRoute.generalSetting,
      AppRoute.chargePointPartnerList,
      AppRoute.contractList,
      AppRoute.maintainerList,
      AppRoute.ticketList,
      AppRoute.maintainerReport,
    ],
    OPERATOR: [
      AppRoute.manageGeneralInfo,
      AppRoute.dashboard,
      AppRoute.manageChargeStations,
      AppRoute.stationList,
      AppRoute.pointList,
      AppRoute.stationsMap,
      AppRoute.batteryList,
      AppRoute.manageVehicles,
      AppRoute.manageVehicleBrand,
      AppRoute.vehicleList,
      AppRoute.rfidList,
      AppRoute.manageChargeBrand,
      AppRoute.inventoryList,
      AppRoute.valuationList,
      AppRoute.insurancePackList,
      AppRoute.voucherList,
      AppRoute.managePaymentTransactions,
      AppRoute.customerTopUpHistory,
      AppRoute.withdrawTransactionList,
      AppRoute.managePayments,
      AppRoute.manageStaffs,
      AppRoute.staffList,
      AppRoute.staffPermissionList,
      AppRoute.manageGroupPermissionInvestor,
      AppRoute.manageGroupPermissionLandlord,
      AppRoute.partnerPermissionList,
      AppRoute.manageOperators,
      AppRoute.customerList,
      AppRoute.managePartners,
      AppRoute.manageDealership,
      AppRoute.saleList,
      AppRoute.saleReport,
      AppRoute.investorList,
      AppRoute.groupList,
      AppRoute.groupReport,
      AppRoute.investmentPackList,
      AppRoute.investorReport,
      AppRoute.landlordsList,
      AppRoute.landlordList,
      AppRoute.landlordReport,
      AppRoute.systemLogList,
      AppRoute.actionLogList,
      AppRoute.superDashboard,
      AppRoute.manageSystem,
      AppRoute.orderList,
      AppRoute.setting,
      AppRoute.pushNotificationList,
      AppRoute.agencyConfigCommission,
      // AppRoute.chargeMaintain,
      // AppRoute.chargeInstallation,
      AppRoute.premisesList,
      AppRoute.tutorialList,
      AppRoute.generalSetting,
      AppRoute.chargePointPartnerList,
      AppRoute.contractList,
    ],
    AGENCY: {
      SALE: [
        AppRoute.manageGeneralInfo,
        AppRoute.saleDashboard,
        AppRoute.dashboard,
        AppRoute.manageChargeStations,
        AppRoute.stationList,
        AppRoute.pointList,
        AppRoute.stationsMap,
        AppRoute.batteryList,
        AppRoute.manageStaffs,
        AppRoute.staffList,
        AppRoute.staffPermissionList,
        AppRoute.manageDealership,
        AppRoute.saleReport,
        AppRoute.saleInfo,
        AppRoute.subSaleList,
        AppRoute.transactionHistory,
        AppRoute.saleHistory,
        AppRoute.agencyAddOrder,
        AppRoute.manageSystem,
        AppRoute.managePartners,
        AppRoute.investorList,
        AppRoute.groupList,
        AppRoute.landlordList,
        AppRoute.agencyOrderList,
        AppRoute.withdrawTransactionList,
        AppRoute.managePaymentTransactions,
        AppRoute.withdrawTransaction,
        AppRoute.chargePointPartnerList,
      ],
      INVESTOR: [
        AppRoute.manageGeneralInfo,
        AppRoute.investorDashboard,
        AppRoute.saleDashboard,
        AppRoute.manageChargeStations,
        AppRoute.stationList,
        AppRoute.stationsMap,
        AppRoute.batteryList,
        AppRoute.manageStaffs,
        AppRoute.manageInvester,
        AppRoute.investorInfo,
        AppRoute.managePayments,
        AppRoute.valuationList,
        AppRoute.investorReport,
        AppRoute.manageSystem,
        AppRoute.staffList,
        AppRoute.staffPermissionList,
        AppRoute.transactionHistory,
        AppRoute.agencyOrderList,
        AppRoute.purchaseOrder,
        AppRoute.saleOrder,
        AppRoute.managePartner,
        AppRoute.groupList,
        AppRoute.landlordList,
        AppRoute.agencyAddOrder,
        AppRoute.withdrawTransaction,
        AppRoute.energyBillList,
        AppRoute.managePartners,
        AppRoute.investorList,
        AppRoute.chargePointPartnerList,
        AppRoute.pointList,
      ],
      LANDLORD: [
        AppRoute.manageGeneralInfo,
        AppRoute.landlordDashboard,
        AppRoute.manageChargeStations,
        AppRoute.stationList,
        AppRoute.pointList,
        AppRoute.stationsMap,
        AppRoute.batteryList,
        AppRoute.manageLandowner,
        AppRoute.landlordInfo,
        AppRoute.landlordsReport,
        AppRoute.manageSystem,
        AppRoute.manageStaffs,
        AppRoute.staffList,
        AppRoute.staffPermissionList,
        AppRoute.transactionHistory,
        AppRoute.electricityPayment,
        AppRoute.landlordReport,
        AppRoute.withdrawTransaction,
        AppRoute.energyBillList,
        AppRoute.premisesList,
        AppRoute.premiseOrderList,
      ],
      GROUP: [
        AppRoute.manageGeneralInfo,
        AppRoute.groupDashboard,
        AppRoute.saleDashboard,
        AppRoute.manageChargeStations,
        AppRoute.stationList,
        AppRoute.stationsMap,
        AppRoute.batteryList,
        AppRoute.groupInfo,
        AppRoute.manageInvestorGroupSection,
        AppRoute.groupReport,
        AppRoute.transactionHistory,
        AppRoute.agencyOrderList,
        AppRoute.purchaseOrder,
        AppRoute.saleOrder,
        AppRoute.managePartners,
        AppRoute.investorList,
        AppRoute.groupList,
        AppRoute.landlordList,
        AppRoute.groupPackHistory,
        AppRoute.withdrawTransaction,
        AppRoute.energyBillList,
        AppRoute.manageSystem,
        AppRoute.manageStaffs,
        AppRoute.staffList,
        AppRoute.staffPermissionList,
        AppRoute.chargePointPartnerList,
      ],
    },
    MAINTAINER: [
      AppRoute.manageGeneralInfo,
      AppRoute.maintainerDashboard,
      AppRoute.manageTickets,
      AppRoute.maintainerInfo,
      AppRoute.myTicket,
      AppRoute.ticketList,
      AppRoute.maintainerReport,
      AppRoute.manageChargeStations,
      AppRoute.maintainerStationList,
      AppRoute.maintainerPointList,
      AppRoute.maintainerStationsMap,
    ],
  },

  permissionCode: {
    dashboardManage: {
      name: 'Xem thông tin tổng quan',
      be_path: null,
      fe_path: '/dashboard',
      method: 'GET',
      code: 'DASHBOARD_MANAGE',
    },
    chargeStationManage: {
      name: 'Quản lý thông tin trạm sạc',
      be_path: null,
      fe_path: '/charge-station',
      method: 'GET',
      code: 'CHARGE_STATION_MANAGE',
    },
    chargeStationCreate: {
      name: 'Tạo trạm sạc',
      be_path: null,
      fe_path: '/charge-station/add',
      method: 'POST',
      code: 'CHARGE_STATION_CREATE',
    },
    chargeStationView: {
      name: 'Xem thông tin trạm sạc',
      be_path: null,
      fe_path: '/charge-station/detail',
      method: 'GET',
      code: 'CHARGE_STATION_VIEW',
    },
    chargeStationUpdate: {
      name: 'Cập nhật thông tin trạm sạc',
      be_path: null,
      fe_path: '/charge-station/edit',
      method: 'PUT',
      code: 'CHARGE_STATION_UPDATE',
    },
    chargeStationDelete: {
      name: 'Xóa trạm sạc',
      be_path: null,
      fe_path: '/charge-station/delete',
      method: 'DELETE',
      code: 'CHARGE_STATION_DELETE',
    },
    chargePointManage: {
      name: 'Quản lý thông tin trụ sạc',
      be_path: null,
      fe_path: '/point',
      method: 'GET',
      code: 'CHARGE_POINT_MANAGE',
    },
    chargePointCreate: {
      name: 'Tạo trụ sạc',
      be_path: null,
      fe_path: '/point/add',
      method: 'POST',
      code: 'CHARGE_POINT_CREATE',
    },
    chargePointView: {
      name: 'Xem thông tin trụ sạc',
      be_path: null,
      fe_path: '/point/detail',
      method: 'GET',
      code: 'CHARGE_POINT_VIEW',
    },
    chargePointUpdate: {
      name: 'Cập nhật thông tin trụ sạc',
      be_path: null,
      fe_path: '/point/edit',
      method: 'PUT',
      code: 'CHARGE_POINT_UPDATE',
    },
    chargePointDelete: {
      name: 'Xóa trụ sạc',
      be_path: null,
      fe_path: '/point/delete',
      method: 'DELETE',
      code: 'CHARGE_POINT_DELETE',
    },
    chargerBrandManage: {
      name: 'Quản lý thông tin hãng sản xuất trụ sạc',
      be_path: null,
      fe_path: '/charge-brand',
      method: 'GET',
      code: 'CHARGER_BRAND_MANAGE',
    },
    chargerBrandCreate: {
      name: 'Tạo hãng sản xuất trụ sạc',
      be_path: null,
      fe_path: '/charge-brand/add',
      method: 'POST',
      code: 'CHARGER_BRAND_CREATE',
    },
    chargerBrandView: {
      name: 'Xem thông tin hãng sản xuất trụ sạc',
      be_path: null,
      fe_path: '/charge-brand/detail',
      method: 'GET',
      code: 'CHARGER_BRAND_VIEW',
    },
    chargerBrandUpdate: {
      name: 'Cập nhật thông tin hãng sản xuất trụ sạc',
      be_path: null,
      fe_path: '/charge-brand/edit',
      method: 'PUT',
      code: 'CHARGER_BRAND_UPDATE',
    },
    chargerBrandDelete: {
      name: 'Xóa hãng sản xuất trụ sạc',
      be_path: null,
      fe_path: '/charge-brand/delete',
      method: 'DELETE',
      code: 'CHARGER_BRAND_DELETE',
    },
    vehicleManage: {
      name: 'Quản lý thông tin xe',
      be_path: null,
      fe_path: '/vehicle',
      method: 'GET',
      code: 'VEHICLE_MANAGE',
    },
    vehicleCreate: {
      name: 'Tạo xe',
      be_path: null,
      fe_path: '/vehicle/add',
      method: 'POST',
      code: 'VEHICLE_CREATE',
    },
    vehicleView: {
      name: 'Xem thông tin xe',
      be_path: null,
      fe_path: '/vehicle/detail',
      method: 'GET',
      code: 'VEHICLE_VIEW',
    },
    vehicleUpdate: {
      name: 'Cập nhật thông tin xe',
      be_path: null,
      fe_path: '/vehicle/edit',
      method: 'PUT',
      code: 'VEHICLE_UPDATE',
    },
    vehicleDelete: {
      name: 'Xóa xe',
      be_path: null,
      fe_path: '/vehicle/delete',
      method: 'DELETE',
      code: 'VEHICLE_DELETE',
    },
    rfidCardManage: {
      name: 'Quản lý thông tin thẻ RFID',
      be_path: null,
      fe_path: '/rfid',
      method: 'GET',
      code: 'RFID_CARD_MANAGE',
    },
    rfidCardCreate: {
      name: 'Tạo thẻ RFID',
      be_path: null,
      fe_path: '/rfid/add',
      method: 'POST',
      code: 'RFID_CARD_CREATE',
    },
    rfidCardView: {
      name: 'Xem thông tin thẻ RFID',
      be_path: null,
      fe_path: '/rfid/detail',
      method: 'GET',
      code: 'RFID_CARD_VIEW',
    },
    rfidCardUpdate: {
      name: 'Cập nhật thông tin thẻ RFID',
      be_path: null,
      fe_path: '/rfid/edit',
      method: 'PUT',
      code: 'RFID_CARD_UPDATE',
    },
    rfidCardDelete: {
      name: 'Xóa thẻ RFID',
      be_path: null,
      fe_path: '/rfid/delete',
      method: 'DELETE',
      code: 'RFID_CARD_DELETE',
    },
    vehicleBrandManage: {
      name: 'Quản lý thông tin hãng xe',
      be_path: null,
      fe_path: '/vehicle-brand',
      method: 'GET',
      code: 'VEHICLE_BRAND_MANAGE',
    },
    vehicleBrandCreate: {
      name: 'Tạo hãng xe',
      be_path: null,
      fe_path: '/vehicle-brand/add',
      method: 'POST',
      code: 'VEHICLE_BRAND_CREATE',
    },
    vehicleBrandView: {
      name: 'Xem thông tin hãng xe',
      be_path: null,
      fe_path: '/vehicle-brand/detail',
      method: 'GET',
      code: 'VEHICLE_BRAND_VIEW',
    },
    vehicleBrandUpdate: {
      name: 'Cập nhật thông tin hãng xe',
      be_path: null,
      fe_path: '/vehicle-brand/edit',
      method: 'PUT',
      code: 'VEHICLE_BRAND_UPDATE',
    },
    vehicleBrandDelete: {
      name: 'Xóa hãng xe',
      be_path: null,
      fe_path: '/vehicle-brand/delete',
      method: 'DELETE',
      code: 'VEHICLE_BRAND_DELETE',
    },
    chargingSessionManage: {
      name: 'Quản lý thông tin phiên sạc',
      be_path: null,
      fe_path: '/charge-transaction',
      method: 'GET',
      code: 'CHARGING_SESSION_MANAGE',
    },
    pricingManage: {
      name: 'Quản lý thông tin định giá sạc điện',
      be_path: null,
      fe_path: '/valuation',
      method: 'GET',
      code: 'PRICING_MANAGE',
    },
    pricingCreate: {
      name: 'Tạo định giá sạc điện',
      be_path: null,
      fe_path: '/valuation/add',
      method: 'POST',
      code: 'PRICING_CREATE',
    },
    pricingView: {
      name: 'Xem thông tin định giá sạc điện',
      be_path: null,
      fe_path: '/valuation/detail',
      method: 'GET',
      code: 'PRICING_VIEW',
    },
    pricingUpdate: {
      name: 'Cập nhật thông tin định giá sạc điện',
      be_path: null,
      fe_path: '/valuation/edit',
      method: 'PUT',
      code: 'PRICING_UPDATE',
    },
    pricingDelete: {
      name: 'Xóa định giá sạc điện',
      be_path: null,
      fe_path: '/valuation/delete',
      method: 'DELETE',
      code: 'PRICING_DELETE',
    },
    driverTopup: {
      name: 'Nạp tiền khách hàng',
      be_path: null,
      fe_path: '/customer-deposit',
      method: 'GET',
      code: 'DRIVER_TOPUP',
    },
    commissionPayment: {
      name: 'Quản lý thông tin chi trả hoa hồng về ví',
      be_path: null,
      fe_path: '/commission-transaction',
      method: 'GET',
      code: 'COMMISSION_PAYMENT',
    },
    agentWithdrawal: {
      name: 'Quản lý thông tin đại lý rút tiền về tài khoản',
      be_path: null,
      fe_path: '/withdraw-transaction',
      method: 'GET',
      code: 'AGENT_WITHDRAWAL',
    },
    driverManage: {
      name: 'Quản lý thông tin danh sách khách hàng',
      be_path: null,
      fe_path: '/customer',
      method: 'GET',
      code: 'DRIVER_MANAGE',
    },
    driverCreate: {
      name: 'Thêm khách hàng',
      be_path: null,
      fe_path: '/customer/add',
      method: 'POST',
      code: 'DRIVER_CREATE',
    },
    driverView: {
      name: 'Xem thông tin khách hàng',
      be_path: null,
      fe_path: '/customer/detail',
      method: 'GET',
      code: 'DRIVER_VIEW',
    },
    driverUpdate: {
      name: 'Cập nhật thông tin khách hàng',
      be_path: null,
      fe_path: '/customer/edit',
      method: 'PUT',
      code: 'DRIVER_UPDATE',
    },
    driverDelete: {
      name: 'Xóa khách hàng',
      be_path: null,
      fe_path: '/customer/delete',
      method: 'DELETE',
      code: 'DRIVER_DELETE',
    },
    saleManage: {
      name: 'Quản lý thông tin danh sách đại lý',
      be_path: null,
      fe_path: '/sale',
      method: 'GET',
      code: 'SALE_MANAGE',
    },
    saleCreate: {
      name: 'Thêm đại lý',
      be_path: null,
      fe_path: '/sale/add',
      method: 'POST',
      code: 'SALE_CREATE',
    },
    saleView: {
      name: 'Xem thông tin đại lý',
      be_path: null,
      fe_path: '/sale/detail',
      method: 'GET',
      code: 'SALE_VIEW',
    },
    saleUpdate: {
      name: 'Cập nhật thông tin đại lý',
      be_path: null,
      fe_path: '/sale/edit',
      method: 'PUT',
      code: 'SALE_UPDATE',
    },
    saleDelete: {
      name: 'Xóa đại lý',
      be_path: null,
      fe_path: '/sale/delete',
      method: 'DELETE',
      code: 'SALE_DELETE',
    },
    saleReconciliationManage: {
      name: 'Quản lý thông tin báo cáo đối soát đại lý',
      be_path: null,
      fe_path: '/sale-report',
      method: 'GET',
      code: 'SALE_RECONCILIATION_MANAGE',
    },
    saleRoleGroupManage: {
      name: 'Quản lý thông tin nhóm quyền đại lý',
      be_path: null,
      fe_path: '/sale-permission',
      method: 'GET',
      code: 'SALE_ROLE_GROUP_MANAGE',
    },
    investorManage: {
      name: 'Quản lý thông tin nhà đầu tư nhượng quyền',
      be_path: null,
      fe_path: '/investor',
      method: 'GET',
      code: 'INVESTOR_MANAGE',
    },
    investorCreate: {
      name: 'Thêm nhà đầu tư nhượng quyền',
      be_path: null,
      fe_path: '/investor/add',
      method: 'POST',
      code: 'INVESTOR_CREATE',
    },
    investorView: {
      name: 'Xem thông tin nhà đầu tư nhượng quyền',
      be_path: null,
      fe_path: '/investor/detail',
      method: 'GET',
      code: 'INVESTOR_VIEW',
    },
    investorUpdate: {
      name: 'Cập nhật thông tin nhà đầu tư nhượng quyền',
      be_path: null,
      fe_path: '/investor/edit',
      method: 'PUT',
      code: 'INVESTOR_UPDATE',
    },
    investorDelete: {
      name: 'Xóa nhà đầu tư nhượng quyền',
      be_path: null,
      fe_path: '/investor/delete',
      method: 'DELETE',
      code: 'INVESTOR_DELETE',
    },
    groupManage: {
      name: 'Quản lý thông tin nhà đầu tư HTKD',
      be_path: null,
      fe_path: '/group',
      method: 'GET',
      code: 'GROUP_MANAGE',
    },
    groupCreate: {
      name: 'Thêm nhà đầu tư HTKD',
      be_path: null,
      fe_path: '/group/add',
      method: 'POST',
      code: 'GROUP_CREATE',
    },
    groupView: {
      name: 'Xem thông tin nhà đầu tư HTKD',
      be_path: null,
      fe_path: '/group/detail',
      method: 'GET',
      code: 'GROUP_VIEW',
    },
    groupUpdate: {
      name: 'Cập nhật thông tin nhà đầu tư HTKD',
      be_path: null,
      fe_path: '/group/edit',
      method: 'PUT',
      code: 'GROUP_UPDATE',
    },
    groupDelete: {
      name: 'Xóa nhà đầu tư HTKD',
      be_path: null,
      fe_path: '/group/delete',
      method: 'DELETE',
      code: 'GROUP_DELETE',
    },
    landlordManage: {
      name: 'Quản lý thông tin chủ đất',
      be_path: null,
      fe_path: '/landlord',
      method: 'GET',
      code: 'LANDLORD_MANAGE',
    },
    landlordCreate: {
      name: 'Thêm chủ đất',
      be_path: null,
      fe_path: '/landlord/add',
      method: 'POST',
      code: 'LANDLORD_CREATE',
    },
    landlordView: {
      name: 'Xem thông tin chủ đất',
      be_path: null,
      fe_path: '/landlord/detail',
      method: 'GET',
      code: 'LANDLORD_VIEW',
    },
    landlordUpdate: {
      name: 'Cập nhật thông tin chủ đất',
      be_path: null,
      fe_path: '/landlord/edit',
      method: 'PUT',
      code: 'LANDLORD_UPDATE',
    },
    landlordDelete: {
      name: 'Xóa chủ đất',
      be_path: null,
      fe_path: '/landlord/delete',
      method: 'DELETE',
      code: 'LANDLORD_DELETE',
    },
    orderManage: {
      name: 'Quản lý thông tin đơn hàng',
      be_path: null,
      fe_path: '/order',
      method: 'GET',
      code: 'ORDER_MANAGE',
    },
    orderCreate: {
      name: 'Tạo đơn hàng',
      be_path: null,
      fe_path: '/order/add',
      method: 'POST',
      code: 'ORDER_CREATE',
    },
    orderView: {
      name: 'Xem thông tin đơn hàng',
      be_path: null,
      fe_path: '/order/detail',
      method: 'GET',
      code: 'ORDER_VIEW',
    },
    orderUpdate: {
      name: 'Cập nhật thông tin đơn hàng',
      be_path: null,
      fe_path: '/order/edit',
      method: 'PUT',
      code: 'ORDER_UPDATE',
    },
    orderDelete: {
      name: 'Xóa đơn hàng',
      be_path: null,
      fe_path: '/order/delete',
      method: 'DELETE',
      code: 'ORDER_DELETE',
    },
    staffManage: {
      name: 'Quản lý thông tin nhân viên',
      be_path: null,
      fe_path: '/staff',
      method: 'GET',
      code: 'STAFF_MANAGE',
    },
    staffCreate: {
      name: 'Thêm nhân viên',
      be_path: null,
      fe_path: '/staff/add',
      method: 'POST',
      code: 'STAFF_CREATE',
    },
    staffView: {
      name: 'Xem thông tin nhân viên',
      be_path: null,
      fe_path: '/staff/detail',
      method: 'GET',
      code: 'STAFF_VIEW',
    },
    staffUpdate: {
      name: 'Cập nhật thông tin nhân viên',
      be_path: null,
      fe_path: '/staff/edit',
      method: 'PUT',
      code: 'STAFF_UPDATE',
    },
    staffDelete: {
      name: 'Xóa nhân viên',
      be_path: null,
      fe_path: '/staff/delete',
      method: 'DELETE',
      code: 'STAFF_DELETE',
    },
  },

  permissionCodeList: {
    AGENCY: {
      SALE: [
        'AGENCY_DASHBOARD',
        'SYSTEM_NOTIFICATION_MANAGE',
        'SYSTEM_NOTIFICATION_BUSINESS',
        'SYSTEM_NOTIFICATION_OPERATION',
        'SYSTEM_NOTIFICATION_PROMOTION',
        'SALE_MANAGE',
        'SALE_VIEW',
        'SALE_UPDATE',
        'CONTRACT_MANAGE',
        'CONTRACT_VIEW',
        'CONTRACT_SIGN',
        'BANK_MANAGE',
        'BANK_VIEW',
        'BANK_CREATE',
        'BANK_UPDATE',
        'BANK_DELETE',
        'SALE_KPI',
        'SUB_SALE_MANAGE',
        'SUB_SALE_VIEW',
        'SUB_SALE_CREATE',
        'SUB_SALE_UPDATE',
        'SUB_SALE_DELETE',
        'SUB_SALE_KPI',
        'ORDER_MANAGE',
        'ORDER_VIEW',
        'ORDER_CREATE',
        'ORDER_UPDATE',
        'ORDER_DELETE',
        'SALE_RECONCILIATION_MANAGE',
        'SALE_RECONCILIATION_VIEW',
        'SALE_RECONCILIATION_SIGN',
        'SALE_RECONCILIATION_UPDATE',
        'AGENCY_WITHDRAW',
        'TRANSACTION_HISTORY',
        'GROUP_MANAGE',
        'GROUP_VIEW',
        'GROUP_CREATE',
        'GROUP_UPDATE',
        'GROUP_DELETE',
        'INVESTOR_MANAGE',
        'INVESTOR_VIEW',
        'INVESTOR_CREATE',
        'INVESTOR_UPDATE',
        'INVESTOR_DELETE',
        'LANDLORD_MANAGE',
        'LANDLORD_VIEW',
        'LANDLORD_CREATE',
        'LANDLORD_UPDATE',
        'LANDLORD_DELETE',
        'CHARGE_STATION_MAP',
        'STAFF_MANAGE',
        'STAFF_VIEW',
        'STAFF_CREATE',
        'STAFF_UPDATE',
        'STAFF_DELETE',
        'STAFF_PERMISSION_MANAGE',
      ],
      GROUP: [
        'AGENCY_DASHBOARD',
        'GROUP_DASHBOARD',
        'SALE_DASHBOARD',
        'SYSTEM_NOTIFICATION_MANAGE',
        'SYSTEM_NOTIFICATION_BUSINESS',
        'SYSTEM_NOTIFICATION_OPERATION',
        'SYSTEM_NOTIFICATION_PROMOTION',
        'GROUP_INFO_MANAGE',
        'GROUP_INFO_VIEW',
        'GROUP_INFO_UPDATE',
        'CONTRACT_MANAGE',
        'CONTRACT_VIEW',
        'CONTRACT_SIGN',
        'BANK_MANAGE',
        'BANK_VIEW',
        'BANK_CREATE',
        'BANK_UPDATE',
        'BANK_DELETE',
        'PURCHASE_ORDER',
        'ORDER_MANAGE',
        'ORDER_VIEW',
        'ORDER_CREATE',
        'ORDER_UPDATE',
        'ORDER_DELETE',
        'GROUP_RECONCILIATION_MANAGE',
        'GROUP_RECONCILIATION_VIEW',
        'GROUP_RECONCILIATION_SIGN',
        'GROUP_RECONCILIATION_UPDATE',
        'AGENCY_WITHDRAW',
        'TRANSACTION_HISTORY',
        'CHARGE_STATION_VIEW',
        'CHARGE_STATION_MAP',
        'CHARGE_TRANSACTION_MANAGE',
        'GROUP_MANAGE',
        'GROUP_VIEW',
        'GROUP_CREATE',
        'GROUP_UPDATE',
        'GROUP_DELETE',
        'INVESTOR_MANAGE',
        'INVESTOR_VIEW',
        'INVESTOR_CREATE',
        'INVESTOR_UPDATE',
        'INVESTOR_DELETE',
        'LANDLORD_MANAGE',
        'LANDLORD_VIEW',
        'LANDLORD_CREATE',
        'LANDLORD_UPDATE',
        'LANDLORD_DELETE',
        'STAFF_MANAGE',
        'STAFF_VIEW',
        'STAFF_CREATE',
        'STAFF_UPDATE',
        'STAFF_DELETE',
        'STAFF_PERMISSION_MANAGE',
      ],
      INVESTOR: [
        'AGENCY_DASHBOARD',
        'INVESTOR_DASHBOARD',
        'SALE_DASHBOARD',
        'SYSTEM_NOTIFICATION_MANAGE',
        'SYSTEM_NOTIFICATION_BUSINESS',
        'SYSTEM_NOTIFICATION_OPERATION',
        'SYSTEM_NOTIFICATION_PROMOTION',
        'INVESTOR_INFO_MANAGE',
        'INVESTOR_INFO_VIEW',
        'INVESTOR_INFO_UPDATE',
        'CONTRACT_MANAGE',
        'CONTRACT_VIEW',
        'CONTRACT_SIGN',
        'BANK_MANAGE',
        'BANK_VIEW',
        'BANK_CREATE',
        'BANK_UPDATE',
        'BANK_DELETE',
        'PURCHASE_ORDER',
        'ORDER_MANAGE',
        'ORDER_VIEW',
        'ORDER_CREATE',
        'ORDER_UPDATE',
        'ORDER_DELETE',
        'INVESTOR_RECONCILIATION_MANAGE',
        'INVESTOR_RECONCILIATION_VIEW',
        'INVESTOR_RECONCILIATION_SIGN',
        'INVESTOR_RECONCILIATION_UPDATE',
        'AGENCY_WITHDRAW',
        'TRANSACTION_HISTORY',
        'CHARGE_STATION_MANAGE',
        'CHARGE_STATION_VIEW',
        'CHARGE_STATION_UPDATE',
        'CHARGE_STATION_ACTIVATE',
        'CHARGE_STATION_MAP',
        'ENERGY_BILL_MANAGE',
        'ENERGY_BILL_VIEW',
        'ENERGY_BILL_UPDATE',
        'ENERGY_BILL_RESPONSE',
        'VALUATION_MANAGE',
        'VALUATION_VIEW',
        'VALUATION_CREATE',
        'VALUATION_UPDATE',
        'VALUATION_DELETE',
        'CHARGE_TRANSACTION_MANAGE',
        'GROUP_MANAGE',
        'GROUP_VIEW',
        'GROUP_CREATE',
        'GROUP_UPDATE',
        'GROUP_DELETE',
        'INVESTOR_MANAGE',
        'INVESTOR_VIEW',
        'INVESTOR_CREATE',
        'INVESTOR_UPDATE',
        'INVESTOR_DELETE',
        'LANDLORD_MANAGE',
        'LANDLORD_VIEW',
        'LANDLORD_CREATE',
        'LANDLORD_UPDATE',
        'LANDLORD_DELETE',
        'STAFF_MANAGE',
        'STAFF_VIEW',
        'STAFF_CREATE',
        'STAFF_UPDATE',
        'STAFF_DELETE',
        'STAFF_PERMISSION_MANAGE',
      ],
      LANDLORD: [
        'AGENCY_DASHBOARD',
        'SYSTEM_NOTIFICATION_MANAGE',
        'SYSTEM_NOTIFICATION_BUSINESS',
        'SYSTEM_NOTIFICATION_OPERATION',
        'SYSTEM_NOTIFICATION_PROMOTION',
        'LANDLORD_INFO_MANAGE',
        'LANDLORD_INFO_VIEW',
        'LANDLORD_INFO_UPDATE',
        'CONTRACT_MANAGE',
        'CONTRACT_VIEW',
        'CONTRACT_SIGN',
        'BANK_MANAGE',
        'BANK_VIEW',
        'BANK_CREATE',
        'BANK_UPDATE',
        'BANK_DELETE',
        'PREMISE_ORDER_MANAGE',
        'LANDLORD_RECONCILIATION_MANAGE',
        'LANDLORD_RECONCILIATION_VIEW',
        'LANDLORD_RECONCILIATION_SIGN',
        'LANDLORD_RECONCILIATION_UPDATE',
        'AGENCY_WITHDRAW',
        'TRANSACTION_HISTORY',
        'CHARGE_STATION_MANAGE',
        'CHARGE_STATION_VIEW',
        'CHARGE_STATION_UPDATE',
        'CHARGE_STATION_ACTIVATE',
        'PREMISE_MANAGE',
        'CHARGE_STATION_MAP',
        'ENERGY_BILL_MANAGE',
        'ENERGY_BILL_VIEW',
        'ENERGY_BILL_UPDATE',
        'ENERGY_BILL_RESPONSE',
        'CHARGE_TRANSACTION_MANAGE',
        'STAFF_MANAGE',
        'STAFF_VIEW',
        'STAFF_CREATE',
        'STAFF_UPDATE',
        'STAFF_DELETE',
        'STAFF_PERMISSION_MANAGE',
      ]
    }
  }
};

export default AppConstants;
